module.exports = __webpack_public_path__ + "img/ic_tick.28670fb0.svg";